'use client';
import {
  AppstoreOutlined,
  CalendarOutlined,
  CloseOutlined,
  ContactsOutlined,
  MenuOutlined,
  RightOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { useState } from 'react';
import Link from 'next/link';

const quickLinks = [
  {
    href: '/about',
    label: 'about',
    icon: <AppstoreOutlined />,
  },
  {
    href: '/contact',
    label: 'contact',
    icon: <ContactsOutlined />,
  },
  {
    href: '/experience',
    label: 'experience',
    icon: <CalendarOutlined />,
  },
  {
    href: '/profile',
    label: 'account',
    icon: <UserOutlined />,
  },
];

const DrawerMenuMobile = ({ data, collections = [], labels }) => {
  const [leftDrawerVisible, setLeftDrawerVisible] = useState(false);

  const onClose = () => {
    setTimeout(() => {
      setLeftDrawerVisible(false);
    }, 300);
  };

  const showDrawer = () => {
    setLeftDrawerVisible(true);
  };

  const collectionItems = Array.isArray(collections) && collections.length
    ? collections
    : Array.isArray(data)
      ? data
      : [];

  return (
    <div>
      <button
        onClick={showDrawer}
        className="relative z-20 mr-2 text-gray-600 transition hover:text-[#667348]"
        aria-label={labels.openMenu}
      >
        <MenuOutlined />
      </button>

      <div
        className={`fixed inset-0 z-40 bg-[#2f2a22]/45 backdrop-blur-[2px] transition-opacity ${
          leftDrawerVisible ? 'opacity-100' : 'pointer-events-none opacity-0'
        }`}
        onClick={onClose}
      />

      <div
        className={`fixed left-0 top-0 z-50 flex h-full w-[88vw] max-w-[360px] flex-col overflow-hidden bg-[#fbf6ee] shadow-[0_24px_60px_rgba(48,40,28,0.22)] transition-transform duration-300 ${
          leftDrawerVisible ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <div className="h-1 w-full bg-gradient-to-r from-[#667348] via-[#b9924f] to-[#667348]" />

        <div className="relative border-b border-[#dccfb9] bg-[linear-gradient(180deg,rgba(255,255,255,0.9),rgba(246,237,223,0.95))] px-5 pb-5 pt-6">
          
          <h2
            className="mt-2 pr-10 text-[25px] leading-tight text-[#223A27]"
            style={{ fontFamily: 'Georgia, Times New Roman, serif' }}
          >
            {labels.mobileMenuTitle}
          </h2>
          

          <button
            className="absolute right-4 top-4 flex h-10 w-10 items-center justify-center rounded-full border border-[#d9c8ab] bg-white/80 text-[#5f5a4d] transition hover:border-[#667348] hover:text-[#667348]"
            onClick={onClose}
            aria-label={labels.closeMenu}
          >
            <CloseOutlined />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto px-4 pb-5 pt-4">
          <div className="rounded-[24px] border border-[#e4d7c4] bg-white/80 p-3 shadow-[0_10px_30px_rgba(76,68,56,0.05)]">
            <p className="px-2 pb-2 text-[11px] font-semibold uppercase tracking-[0.24em] text-[#a0813a]">
              {labels.mobileMenuCategories}
            </p>

            <div className="space-y-2">
              {Array.isArray(data) && data.length > 0 ? (
                data.map(item => (
                  <Link
                    key={item.slug}
                    href={`/${item.slug}`}
                    onClick={onClose}
                    className="flex items-center justify-between rounded-[18px] border border-transparent bg-[#f7f1e6] px-4 py-3 text-[#2f3c30] transition hover:border-[#d5c29d] hover:bg-white"
                  >
                    <div className="min-w-0">
                      <p className="truncate text-[15px] font-medium leading-6">
                        {item.name || item.title || item.slug}
                      </p>
                      <p className="text-[11px] uppercase tracking-[0.16em] text-[#8d7f66]">
                        {labels.viewCategory}
                      </p>
                    </div>
                    <span className="ml-3 flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-[#d8ccb8] text-[12px] text-[#7d755f]">
                      <RightOutlined />
                    </span>
                  </Link>
                ))
              ) : (
                <div className="rounded-[18px] bg-[#f7f1e6] px-4 py-4 text-sm text-[#6e6758]">
                  {labels.noCategoriesAvailable}
                </div>
              )}
            </div>
          </div>

          <div className="mt-4 rounded-[24px] border border-[#e4d7c4] bg-white/80 p-3 shadow-[0_10px_30px_rgba(76,68,56,0.05)]">
            <p className="px-2 pb-2 text-[11px] font-semibold uppercase tracking-[0.24em] text-[#a0813a]">
              {labels.mobileMenuCollections}
            </p>

            <div className="space-y-2">
              {collectionItems.length > 0 ? (
                collectionItems.map(item => (
                  <Link
                    key={item.slug}
                    href={`/collection/${item.slug}`}
                    onClick={onClose}
                    className="flex items-center justify-between rounded-[18px] border border-transparent bg-[#f7f1e6] px-4 py-3 text-[#2f3c30] transition hover:border-[#d5c29d] hover:bg-white"
                  >
                    <div className="min-w-0">
                      <p className="truncate text-[15px] font-medium leading-6">
                        {item.name || item.title || item.slug}
                      </p>
                      <p className="text-[11px] uppercase tracking-[0.16em] text-[#8d7f66]">
                        {labels.viewCollection}
                      </p>
                    </div>
                    <span className="ml-3 flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-[#d8ccb8] text-[12px] text-[#7d755f]">
                      <RightOutlined />
                    </span>
                  </Link>
                ))
              ) : (
                <div className="rounded-[18px] bg-[#f7f1e6] px-4 py-4 text-sm text-[#6e6758]">
                  {labels.noCollectionsAvailable}
                </div>
              )}
            </div>
          </div>

          <div className="mt-4 rounded-[24px] border border-[#e4d7c4] bg-white/75 p-3 shadow-[0_10px_30px_rgba(76,68,56,0.05)]">
            <p className="px-2 pb-2 text-[11px] font-semibold uppercase tracking-[0.24em] text-[#a0813a]">
              {labels.quickNavTitle}
            </p>
            <div className="grid grid-cols-2 gap-2">
              {quickLinks.map(link => (
                <Link
                  key={link.href}
                  href={link.href}
                  onClick={onClose}
                  className="rounded-[18px] border border-[#efe4d3] bg-[#fffdfa] px-3 py-3 text-[#4d463b] transition hover:border-[#cdb27b] hover:bg-[#f7f1e6]"
                >
                  <span className="mb-2 flex h-9 w-9 items-center justify-center rounded-full bg-[#f1e7d4] text-[#667348]">
                    {link.icon}
                  </span>
                  <span className="block text-[13px] font-medium leading-5">
                    {link.label === 'account'
                      ? labels.account
                      : link.label === 'about'
                        ? labels.aboutUs
                        : link.label === 'contact'
                          ? labels.contactUs
                          : link.label === 'experience'
                            ? labels.headerExperience
                            : link.label}
                  </span>
                </Link>
              ))}
            </div>
          </div>
        </div>

        {/* <div className="border-t border-[#dccfb9] bg-[#f7f0e2] px-5 py-4">
          <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-[#9f8756]">
            Mộc Phúc Duyên
          </p>
          <p className="mt-1 text-sm leading-6 text-[#6e6758]">
            Không gian trà thanh nhã, tinh tuyển bộ sưu tập và trải nghiệm thưởng trà theo đúng phong cách hiện tại của website.
          </p>
        </div> */}
      </div>
    </div>
  );
};

export default DrawerMenuMobile;
